import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SpinnerService, DialogService, DataService, CoreService, SaveDataRequest, DialogResult } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ComponentDeactivationService } from 'src/app/services/component-deactivation.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { ErrorService } from 'src/app/services/error.service';
import { AGE_THRESHOLDS, CARD_TYPE_ID, FORM_IDENTIFIERS, NAV_TAB_NUMBERS, NominationFields, OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, SAVE_RESULT_STATUS, VptasCommonConstants } from 'src/app/constants/app-data.constants';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import * as _ from 'lodash';
import { FormArray, FormGroup } from '@angular/forms';
import { CentrelinkCardCheckResponse } from 'src/app/interfaces/centrelink-card-check-response.interface';
import { DateUtilService } from 'src/app/services/date-util.service';
import { VptasSelfNominationRequest } from 'src/app/models/vptas-self-nomination-request';

@Component({
  selector: 'app-victorian-patient-transport-assistance-scheme-nominated-patient-details',
  templateUrl: './victorian-patient-transport-assistance-scheme-nominated-patient-details.component.html',
  styleUrl: './victorian-patient-transport-assistance-scheme-nominated-patient-details.component.scss'
})
export class VictorianPatientTransportAssistanceSchemeNominatedPatientDetailsComponent 
  extends BaseCardSetDetailComponent
  implements OnInit, AfterViewInit
{

  userId: string | null = null;
  nominatedPatientDetails: any = null;
  fieldTypeReplacements = OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS;
  activeDialog: any;
  id: any;
  source: any;
  appMenuService: any;
   formServiceEndpoint: string = API_ENDPOINT_KEYS.getVptasNominatedPatientDetailsConfigAndResponse;
  templateId: number = TEMPLATES.victorianPatientTransportAssistanceSchemeNominatedPatientDetails;
  versionNo: number = VERSIONS.latest;
  isLoading: boolean = false;
  showSelfNominateAsPatientButton: boolean = false;
  applicantProfileUpdated: boolean = false;
  loadingStep: string = '';
  model: any = {};
  private dvaCardValidationCache: Map<number, boolean> = new Map();

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected componentDeactivationService: ComponentDeactivationService,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private dataService: DataService,
    private errorService: ErrorService,
    protected responseParserService: ResponseParserService,
    protected cdr: ChangeDetectorRef,
    private dateUtilService: DateUtilService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    // Extract the ID from route parameters
    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        if (id) {
          this.id = id;
          console.log('Person ID from route:', this.id);
          // The form service endpoint is already set to use the correct endpoint
        }
      })
    );

    
    this.coreService.conditionFunctions = {
      showAutocompletedFieldsMessage: (sectionIndex) => this.showAutocompletedFieldsMessage(sectionIndex),
      showRelationshipToPatient: (sectionIndex) => !this.isSelfNominationBySectionIndex(sectionIndex),
      showMissingMandatoryFieldsMessage: (sectionIndex) => this.showMissingMandatoryFieldsMessage(sectionIndex),
      showApplicantProfileUpdatedMessage: (sectionIndex) => this.showApplicantProfileUpdatedMessage(sectionIndex),
      checkCentrelinkVeteransAffairsCard: (sectionIndex) => this.checkCentrelinkVeteransAffairsCard(sectionIndex),
      showConcessionCardDetail: (sectionIndex) => this.showConcessionCardDetail(sectionIndex)
  };

    this.coreService.applicationFunctions = {
      exit: () => this.cancel(),
      selfNominateAsPatient: () => this.selfNominateAsPatient(),
      showSelfNominateAsPatientButton: () => this.showSelfNominateAsPatientButton,
      checkEitherMobileOrOther: (sectionIndex) => this.checkEitherMobileOrOtherPhone(sectionIndex),
      dvaCardCheck: (sectionIndex) => this.dvaCardCheck(sectionIndex),
      genderMandatory: (sectionIndex) => this.genderMandatory(sectionIndex),
      aboriginalOrTorresStraitIslanderDescentMandatory: (sectionIndex) => this.aboriginalOrTorresStraitIslanderDescentMandatory(sectionIndex),
  };
    this.coreService.repeatingSectionFunctions = {
      onBeforeSaveNominatedpatient: (itemIndex: number, onComplete: (cancel: boolean) => void): Promise<void> => this.onBeforeSaveNominatedpatient(itemIndex, onComplete),
      onBeforeDeleteNominatedpatient: (itemIndex: number, onComplete: (cancel: boolean) => void): Promise<void> => this.onBeforeDeleteNominatedpatient(itemIndex, onComplete),
    };
  }

  aboriginalOrTorresStraitIslanderDescentMandatory(sectionIndex: any) {
    return true;
  }
  
  genderMandatory(sectionIndex: any) {
    return true;
  }

  ngAfterViewInit(): void {
    let attempts = 0;
    const maxAttempts = 100; // e.g., 10 seconds if interval is 100ms
    const interval = setInterval(() => {
      const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
      if (formGroup) {
        this.disableFieldsForSelfNomination(formGroup);

        // Check if at least one self-nomination section has all relevant fields disabled
        const formNominatedPatientsSection = formGroup.get(
          `tabs.tab${NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails}.page${PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails}.nominatedPatientDetailsSection`
        ) as FormArray;
        let allDisabled = true;
        if (formNominatedPatientsSection) {
          for (let i = 0; i < formNominatedPatientsSection.length; i++) {
            const sectionGroup = formNominatedPatientsSection.at(i) as FormGroup;
            const isSelfNomination = sectionGroup.get('isSelfNomination')?.value;
            if (isSelfNomination) {
              // Check a couple of fields
              if (
                sectionGroup.get('firstName')?.enabled ||
                sectionGroup.get('veteransAffairsCardNumber')?.enabled
              ) {
                allDisabled = false;
                break;
              }
            }
          }
        }
        if (allDisabled) {
          clearInterval(interval);
        }
      }
      attempts++;
      if (attempts > maxAttempts) {
        clearInterval(interval);
        console.warn('Fields could not be reliably disabled after waiting.');
      }
    }, 100);
  }

  formLoaded(event: any): void {
    if (event) {
      this.showSelfNominateAsPatientButton = event.showSelfNominateAsPatientButton;
      this.applicantProfileUpdated = event.applicantProfileUpdated;
    }
    this.coreService.fileUploadFormIdentifiers['dependantDocument'] = FORM_IDENTIFIERS.vptsFormIdentifier;

    this.removeValidationFromSelfNiminationPopup();
  }

  modelChanged($event: any) {
    // Reserved for future model change logic
  }

  save(event: any): void {
    if (event.isFormValid === false) {
      this.baseForm.markAllFieldsAsTouched();
      this.baseForm.showValidationSummary(true);
      return;
    }
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: '',
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: false,
    };
    this.saveData(saveDataRequest);
  }

  cancel(): void {
    this.navigateToPersonDetail();
  }

  /**
   * Deletes self-nomination records via API.
   */
  private deleteSelfNomination(): void {
    this.spinnerService.showSpinner();
    const urlWithId = this.id ? `${API_ENDPOINTS.vptasNominatedPatient.delete}/${this.id}` : API_ENDPOINTS.vptasNominatedPatient.delete;
    this.appDataService.post(urlWithId, null)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => {
          this.spinnerService.hideSpinner();
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.navigateBackToHome(true); // Navigate back ignoring unsaved changes
          } else {
            this.navigateBackToHome();
          }
        },
        error: error => {
          console.error('deleteSelfNomination error:', error);
          // Navigate back even if delete fails
          this.navigateBackToHome();
        }
      });
  }

  /**
   * Handles self-nomination as a patient and updates the nominatedPatientDetailsSection.
   */
  private selfNominateAsPatient(): void {
    this.activeDialog = POP_UP_CODES.vptasNominatedPatientDetails.selfNomination;
    this.dialogService.showDialog(this.activeDialog);
  }
  
  dialogButton_selfNomination_Clicked(event: any) {
    if (event == null)
      return;
    this.spinnerService.showSpinner();
    let request: VptasSelfNominationRequest = {
      genderId: event.genderId,
      aboriginalOrTorresStraitIslanderDescentId: event.aboriginalOrTorresStraitIslanderDescentId
    };
    const urlWithId = this.id ? `${API_ENDPOINTS.vptasNominatedPatient.selfNominate}/${this.id}` : API_ENDPOINTS.vptasNominatedPatient.save;
    this.appDataService.post(urlWithId, request)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => {
          this.spinnerService.hideSpinner();
          this.showSelfNominateAsPatientButton = false;
        })
      )
      .subscribe({
        next: (data: any) => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.reloadPage();
          }
        },
        error: error => {
          this.checkNotInVictoriaMessage(error.error);
          console.error('selfNominateAsPatient error:', error);
        }
      });

  }

  private checkNotInVictoriaMessage(data: any) {
    if (data?.status === SAVE_RESULT_STATUS.invalidActionCode && data?.message) {
      let placeholder = {
        message: data.message
      };
      this.dialogService.showPopup(POP_UP_CODES.vptasNominatedPatientDetails.AddressNotInVictoria, null, placeholder);
    }
  }

  /**
   * Saves the form data.
   */
  private saveData(request: SaveDataRequest): void {
    this.spinnerService.showSpinner();
    const urlWithId = this.id ? `${API_ENDPOINTS.vptasNominatedPatient.save}?id=${this.id}` : API_ENDPOINTS.vptasNominatedPatient.save;
    this.registerSubscription(
      this.dataService.saveData(urlWithId, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => {
            this.spinnerService.hideSpinner();
          })
        )
        .subscribe({
          next: (data: any) => {
            if (data?.status === SAVE_RESULT_STATUS.success) {
              this.navigateToPersonDetail(true);
            };            
          },
          error: error => {
            this.checkNotInVictoriaMessage(error.error);
            console.error('saveData error:', error);
          }
        })
    );
  } 
  
  /**
   * Disables all controls except 'gender' and 'aboriginalOrTorresStraitIslanderDescent' for self-nomination sections.
   */
  private disableFieldsForSelfNomination(formGroup: FormGroup): void {
    const formNominatedPatientsSection = formGroup.get(`tabs.tab${NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails}.page${PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails}.nominatedPatientDetailsSection`) as FormArray;
    if (!formNominatedPatientsSection) return;
    for (let i = 0; i < formNominatedPatientsSection.length; i++) {
      const sectionGroup = formNominatedPatientsSection.at(i) as FormGroup;
      const isSelfNomination = sectionGroup.get('isSelfNomination')?.value;
      if (isSelfNomination) {
        Object.keys(sectionGroup.controls).forEach(controlName => {
          // Always disable all except gender and aboriginalOrTorresStraitIslanderDescent
          if (controlName !== NominationFields.gender
            && controlName !== NominationFields.aboriginalOrTorresStraitIslanderDescent
            && controlName !== NominationFields.consent
            && controlName !== NominationFields.cardType
            && controlName !== NominationFields.cardFullName
          ) {
            sectionGroup.get(controlName)?.disable();
          }
        });
        // Additionally, disable gender and aboriginalOrTorresStraitIslanderDescent if they have a value
        const consentControl = sectionGroup.get(NominationFields.consent);
        if (consentControl && consentControl.value) {
          consentControl.disable();
        }
        const cardFullNameControl = sectionGroup.get(NominationFields.cardFullName);
        if (cardFullNameControl && cardFullNameControl.value) {
          cardFullNameControl.disable();
        }
        const cardTypeControl = sectionGroup.get(NominationFields.cardType);
        if (cardTypeControl && cardTypeControl.value) {
          cardTypeControl.disable();
        }
      }
    }
  }  

  /**
   * Returns true if the section at the given index is a self-nomination.
   */
  private isSelfNominationBySectionIndex(sectionIndex: any): boolean {
    const path = ['form', 'tabs', 'tab2', 'page1', 'nominatedPatientDetailsSection'];
    const current = _.get(this.baseForm.model, path, []);
    const nomineePatientRepeatingPageItemModel = current[sectionIndex];
    return nomineePatientRepeatingPageItemModel?.isSelfNomination;
  }

  private showAutocompletedFieldsMessage(sectionIndex: any): boolean {
    return this.isSelfNominationBySectionIndex(sectionIndex) 
      && !this.showSelfNominateAsPatientButton;
  }

  private showMissingMandatoryFieldsMessage(sectionIndex: any): boolean {
    return this.isSelfNominationBySectionIndex(sectionIndex)
      && (!this.baseForm.model.form.tabs.tab2.page1.nominatedPatientDetailsSection[sectionIndex].gender
      || !this.baseForm.model.form.tabs.tab2.page1.nominatedPatientDetailsSection[sectionIndex].aboriginalOrTorresStraitIslanderDescent);
  }

  private showApplicantProfileUpdatedMessage(sectionIndex: any): boolean {
    return this.isSelfNominationBySectionIndex(sectionIndex) && this.applicantProfileUpdated;
  }

  private dvaCardCheck(sectionIndex: any): boolean {
    const normalizedIndex = Array.isArray(sectionIndex) ? parseInt(sectionIndex[0]) : parseInt(sectionIndex);
    const currentSelectedPatient = this.baseForm?.model?.form?.tabs?.tab2?.page1?.nominatedPatientDetailsSection[normalizedIndex];
    
    if (!currentSelectedPatient?.veteransAffairsCardNumber) {
      this.dvaCardValidationCache.delete(normalizedIndex);
      return true;
    }
    
    if (currentSelectedPatient?.consent != VptasCommonConstants.consentText || 
        currentSelectedPatient.cardType != VptasCommonConstants.veteranCardTypeText) {
      this.dvaCardValidationCache.delete(normalizedIndex);
      return true;
    }
    
    const cardNumberRegex = /^.{6,9}$/;
    if (!cardNumberRegex.test(currentSelectedPatient.veteransAffairsCardNumber)) {
      this.dvaCardValidationCache.delete(normalizedIndex);
      return true;
    }
    const isManualAddress = currentSelectedPatient?.["residentialAddress-manualAddress"] == true;
    const requiredFields = [
      currentSelectedPatient.firstName,
      currentSelectedPatient.surname,
      currentSelectedPatient.dateOfBirth,
      isManualAddress ? currentSelectedPatient?.["residentialAddress-postCode"] : currentSelectedPatient?.["residentialAddress-autoPostCode"],
      isManualAddress ? currentSelectedPatient?.["residentialAddress-streetNumberName"] : currentSelectedPatient?.["residentialAddress-autoStreetNumberName"],
      isManualAddress ? currentSelectedPatient?.["residentialAddress-suburb"] : currentSelectedPatient?.["residentialAddress-autoSuburb"],
      isManualAddress ? currentSelectedPatient?.["residentialAddress-state"] : currentSelectedPatient?.["residentialAddress-autoState"]
    ];
    
    if (requiredFields.some(field => !field)) {
      this.dvaCardValidationCache.delete(normalizedIndex);
      return true;
    }
 
    if (this.dvaCardValidationCache.has(normalizedIndex)) {
      const isValid = this.dvaCardValidationCache.get(normalizedIndex) === true;
      this.dvaCardValidationCache.delete(normalizedIndex);
      return isValid;
    }
    
    this.performAsyncDvaCardCheck(normalizedIndex, currentSelectedPatient);
    return true;
  }

  private async performAsyncDvaCardCheck(sectionIndex: number, currentSelectedPatient: any) {
    try {
      const cardType = currentSelectedPatient.cardType == VptasCommonConstants.veteranCardTypeText ? 
        CARD_TYPE_ID.DepartmentOfVeteransAffairs : CARD_TYPE_ID.Centrelink;
      
      if (currentSelectedPatient.consent != VptasCommonConstants.consentText) return;
      
      const isManualAddress = currentSelectedPatient?.["residentialAddress-manualAddress"] == true;
      const result = await this.checkCentrelinkCard({
        cardType: cardType,
        cardNumber: cardType == CARD_TYPE_ID.Centrelink ? currentSelectedPatient.centrelinkCard : currentSelectedPatient.veteransAffairsCardNumber,
        firstName: currentSelectedPatient.firstName,
        lastName: currentSelectedPatient.surname,
        dateOfBirth: currentSelectedPatient.dateOfBirth,
        postCode: isManualAddress ? currentSelectedPatient?.["residentialAddress-postCode"] : currentSelectedPatient?.["residentialAddress-autoPostCode"],
        streetNumberName: isManualAddress ? currentSelectedPatient?.["residentialAddress-streetNumberName"] : currentSelectedPatient?.["residentialAddress-autoStreetNumberName"],
        suburb: isManualAddress ? currentSelectedPatient?.["residentialAddress-suburb"] : currentSelectedPatient?.["residentialAddress-autoSuburb"],
        state: isManualAddress ? currentSelectedPatient?.["residentialAddress-state"] : currentSelectedPatient?.["residentialAddress-autoState"],
        applicationPeriod: new Date().toDateString()
      });
      
      const isValid = !(result.isValid == false && result.cardGCHFailed == true);
      this.dvaCardValidationCache.set(sectionIndex, isValid);
      
      const formGroup = this.baseForm?.form?.controls?.form as FormGroup;
      const formNominatedPatientsSection = formGroup.get(
        `tabs.tab${NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails}.page${PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails}.nominatedPatientDetailsSection`
      ) as FormArray;
      
      if (!formNominatedPatientsSection) return;
      
      const sectionGroup = formNominatedPatientsSection.at(sectionIndex) as FormGroup;
      const veteransAffairsCardControl = sectionGroup.get(QUESTION_CODES.vptasApplicationForm.veteransAffairsCardNumber);
      
      if (!veteransAffairsCardControl) return;
      
      if (!isValid) {
        veteransAffairsCardControl.markAsTouched();
        veteransAffairsCardControl.markAsDirty();
      } else if (veteransAffairsCardControl.hasError('message')) {
        veteransAffairsCardControl.setErrors(null);
      }
      
      veteransAffairsCardControl.updateValueAndValidity();
    } catch (error) {
      console.error('performAsyncDvaCardCheck error:', error);
    }
  }

  /**
   * Checks if either mobile phone or other phone is present for a given section.
   */
  private checkEitherMobileOrOtherPhone(sectionIndex: any): boolean {
    let mobilePhone = this.responseParserService.findQuestionModel(this.baseForm.model, NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, null, 'nominatedPatientDetailsSection', sectionIndex, 'mobilePhone');
    let otherPhone = this.responseParserService.findQuestionModel(this.baseForm.model, NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, null, 'nominatedPatientDetailsSection', sectionIndex, 'otherPhone');
    return !!(mobilePhone || otherPhone);
  }

  /**
   * Navigates back to the home page.
   */
  private navigateBackToHome(ignoreUnsavedChanges = false): void {
    const target = ROUTE_CONSTANTS.vptasApplication.list.myApplications; // e.g. 'vptas-application-list/my-applications'
    const segments = typeof target === 'string' ? target.replace(/^\//, '').split('/') : [target as any];
    this.navigate(['/', ...segments], ignoreUnsavedChanges);
  }

  private navigateToPersonDetail(ignoreUnsavedChanges = false): void {
    if (this.id) {
      const target = ROUTE_CONSTANTS.person.viewDetail.replace(':id', this.id);
      this.navigate(['/', ...target.split('/')], ignoreUnsavedChanges);
      return;
    }

    this.navigateBackToHome(ignoreUnsavedChanges);
  }

  private checkCentrelinkVeteransAffairsCard(sectionIndex: any): boolean {
    
    const isUnderThresholdAge = this.isUnderThresholdAge(sectionIndex);

    if (isUnderThresholdAge) {
      return false;
    }
    let centrelinkCard = this.responseParserService.findQuestionModel(this.baseForm.model, NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, null, 'nominatedPatientDetailsSection', sectionIndex, 'centrelinkCard');
    let veteransAffairsCardNumber = this.responseParserService.findQuestionModel(this.baseForm.model, NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, null, 'nominatedPatientDetailsSection', sectionIndex, 'veteransAffairsCardNumber');
    return !!(centrelinkCard || veteransAffairsCardNumber);
  }

  private showConcessionCardDetail(sectionIndex: any): boolean {

    const isUnderThresholdAge = this.isUnderThresholdAge(sectionIndex);
    if (isUnderThresholdAge) {
      return false;
    }
    //get consent from response parser service
    let consent = this.responseParserService.findQuestionModel(this.baseForm.model, NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, null, 'nominatedPatientDetailsSection', sectionIndex, 'consent');
    if (consent !== VptasCommonConstants.consentText) {
      return false;
    }
    return false;
  }

  private isUnderThresholdAge(sectionIndex: any): boolean {
    
    let dateOfBirth = this.responseParserService.findQuestionModel(this.baseForm.model, NAV_TAB_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, PAGE_NUMBERS.vptasNominatedPatientDetailsForm.nominatedPatientDetails, null, 'nominatedPatientDetailsSection', sectionIndex, 'dateOfBirth');
    
    if (!dateOfBirth) {
      return false;
    }

    const isUnderThresholdAge = this.dateUtilService.isUnderAge(dateOfBirth, AGE_THRESHOLDS.vptasConcessionCardMinimumAge);
    
    return isUnderThresholdAge;  
  }  
  
  private async onBeforeSaveNominatedpatient(itemIndex: number, onComplete: (cancel: boolean) => void): Promise<void> {
    const patients = this.baseForm?.model?.form?.tabs?.tab2?.page1?.nominatedPatientDetailsSection;
    const selectedPatient = patients[itemIndex];
    const currentSelectedPatient = selectedPatient;
    let isManualAddress = currentSelectedPatient?.["residentialAddress-manualAddress"] == true;
    let streetNumberName = isManualAddress ? currentSelectedPatient?.["residentialAddress-streetNumberName"] : currentSelectedPatient?.["residentialAddress-autoStreetNumberName"];
    let suburb = isManualAddress ? currentSelectedPatient?.["residentialAddress-suburb"] : currentSelectedPatient?.["residentialAddress-autoSuburb"];
    let state = isManualAddress ? currentSelectedPatient?.["residentialAddress-state"] : currentSelectedPatient?.["residentialAddress-autoState"];
    let postCode = isManualAddress ? currentSelectedPatient?.["residentialAddress-postCode"] : currentSelectedPatient?.["residentialAddress-autoPostCode"];
    let address = streetNumberName + ', ' + suburb + ', ' + state + ' ' + postCode;
    
    // Flags for validation results
    let isVictoriaStateInvalid = false;
    let isCentrelinkCardInvalid = false;
    
    // Check for victoria state
    if (!state || (state.trim().toLowerCase() != 'vic' && state.trim().toLowerCase() != 'victoria')) { 
      isVictoriaStateInvalid = true;
    }
    
    // Check for centrelink/veteran affairs card
    const isCentrelinkCardValid = await this.validateCentrelinkCard(currentSelectedPatient, postCode, streetNumberName, suburb, state);
    if (!isCentrelinkCardValid) {
      isCentrelinkCardInvalid = true;
    }
    
    // Show popups sequentially based on validation results
    if (isCentrelinkCardInvalid) {
      const centrelinkPopupCode = POP_UP_CODES.common.centrelinkCardMatch;
      
      if (isVictoriaStateInvalid) {
        // Show centrelink popup first, then victoria popup
        this.dialogService.showConfirmPopup(centrelinkPopupCode, {})
          .pipe(take(1))
          .subscribe(() => {
        // Only show victoria popup
          this.showVictoriaStateInvalidMessage(address);
          });
      } else {
        // Only show centrelink popup
        this.dialogService.showConfirmPopup(centrelinkPopupCode, {}).pipe(take(1)).subscribe();
      }
    } else if (isVictoriaStateInvalid) {
      // Only show victoria popup
      this.showVictoriaStateInvalidMessage(address);
    }
        
    onComplete(false);
  }

  private async validateCentrelinkCard(currentSelectedPatient: any, postCode: string, streetNumberName: string, suburb: string, state: string): Promise<boolean> {
    if (currentSelectedPatient?.consent !== VptasCommonConstants.consentText) {
      return true; // Valid if no consent given
    }
    
    let cardType = currentSelectedPatient.cardType == VptasCommonConstants.veteranCardTypeText ? 
      CARD_TYPE_ID.DepartmentOfVeteransAffairs : CARD_TYPE_ID.Centrelink;
    
    var result = await this.checkCentrelinkCard({
      cardType: cardType,
      cardNumber: cardType == CARD_TYPE_ID.Centrelink ? currentSelectedPatient.centrelinkCard : currentSelectedPatient.veteransAffairsCardNumber,
      firstName: currentSelectedPatient.firstName,
      lastName: currentSelectedPatient.surname,
      dateOfBirth: currentSelectedPatient.dateOfBirth,
      postCode: postCode,
      streetNumberName: streetNumberName,
      suburb: suburb,
      state: state,
      applicationPeriod: new Date().toDateString()
    });
    
    return result.isValid !== false;
  }

  async checkCentrelinkCard(request): Promise<CentrelinkCardCheckResponse> {
    this.spinnerService.showSpinner();
    return await this.appDataService
      .post(API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.centrelinkCardCheck, request)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      ).toPromise();
  }

  private async onBeforeDeleteNominatedpatient(itemIndex: number, onComplete: (cancel: boolean) => void): Promise<void> {
    var popupCode = POP_UP_CODES.victorianPatientTransportAssistanceScheme.deleteNominatedPatientNotification;
    this.dialogService.showDialog(popupCode);
    onComplete(false);
  }

  private showVictoriaStateInvalidMessage(address: string): void {
    let data = {
      status: SAVE_RESULT_STATUS.invalidActionCode,
      message: address
    };
    this.checkNotInVictoriaMessage(data);
  }

  private removeValidationFromSelfNiminationPopup() {
    var selfNominationPopup = this.dialogService.findPopupByCode(POP_UP_CODES.vptasNominatedPatientDetails.selfNomination);
    selfNominationPopup.questions.forEach(selfNominationQuestions => {
      selfNominationQuestions.props.required = false;
    });
  }
}
